import { TaskAttachment } from "../../types/TaskAttachment";
import {
  TaskAttachmentActions,
  TaskAttachmentActionList,
} from "../actions/taskAttachmentAction";

const initialValue: Array<TaskAttachment> = [];

export const taskAttachmentReducer = (
  state: TaskAttachment[] = initialValue,
  action: TaskAttachmentActions,
): TaskAttachment[] => {
  switch (action.type) {
    case TaskAttachmentActionList.ADD_TASK_ATTACHMENT:
      return [...state, action.data];
    case TaskAttachmentActionList.EDIT_TASK_ATTACHMENT: {
      const updated = [...state];
      const index = updated.findIndex((att) => att.id === action.data.id);
      if (index > -1) {
        updated[index] = { ...action.data };
      }
      return updated;
    }
    case TaskAttachmentActionList.FETCH_TASK_ATTACHMENT_BY_ID: {
      const updated = [...state];
      const index = updated.findIndex((att) => att.id === action.data?.id);
      if (action.data) {
        if (index > -1) {
          // Update existing attachment with fetched one
          updated[index] = { ...action.data };
        } else {
          // If not found, add new one
          updated.push(action.data);
        }
      }
      return updated;
    }
    case TaskAttachmentActionList.FETCH_TASK_ATTACHMENTS:
      return action.data;
    case TaskAttachmentActionList.DELETE_TASK_ATTACHMENT:
      return state.filter((att) => att.id !== action.data);
    default:
      return state;
  }
};
